import { configService } from "../utils/ConfigService";
import { getService } from "../utils/Request";

export function register(data: any) {
  const profileEndpoint = configService.getProfileEndpoint();
  return getService()({
    url: "/Person/Register",
    method: "post",
    data,
    baseURL: profileEndpoint + "/api",
  });
}
export function GetAllReligions() {
  const profileEndpoint = configService.getProfileEndpoint();
  return getService()({
    url: "/Person/GetAllReligions",
    method: "get",
    baseURL: profileEndpoint + "/api",
  });
}
